export enum UserStatus {
  NotAuthenticated = "NOT_AUTHENTICATED",
  Authenticated = "AUTHENTICATED",
  Verified = "VERIFIED",
  Subscribed = "SUBSCRIBED",
}
